import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';

/**
 * Fetch an entity by type and ID for chatbot-opened modals.
 * Maps entity_type from the capabilities registry to the correct API endpoint.
 */
export function useEntityForModal(entityType: string | null, entityId: string | null) {
  return useQuery({
    queryKey: ['modal-entity', entityType, entityId],
    queryFn: async () => {
      if (!entityType || !entityId) return null;

      switch (entityType) {
        case 'document': {
          const { data } = await apiClient.get(`/documents/${entityId}`);
          return data;
        }
        case 'ap_posting': {
          const { data } = await apiClient.get(`/ap-postings/${entityId}`);
          return data;
        }
        case 'approval_chain': {
          const { data } = await apiClient.get(`/approval-chains/${entityId}`);
          return data;
        }
        case 'org_unit': {
          const { data } = await apiClient.get(`/org-structure/units/${entityId}`);
          return data;
        }
        case 'ap_line_item': {
          const { data } = await apiClient.get(`/ap-postings/line-items/${entityId}`);
          return data;
        }
        default:
          return null;
      }
    },
    enabled: !!entityType && !!entityId,
  });
}
